import { render, staticRenderFns } from "./worldView.vue?vue&type=template&id=5e56a398&scoped=true&"
import script from "./worldView.vue?vue&type=script&lang=js&"
export * from "./worldView.vue?vue&type=script&lang=js&"
import style0 from "./worldView.vue?vue&type=style&index=0&id=5e56a398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56a398",
  null
  
)

export default component.exports